export default __webpack_public_path__ + "static/casino-comics-7f0c354b8e0d50300aaec4f26f9d709c.pdf";